"use strict";
import { importPageLifecycle } from "./asyncModules/importPageLifecycle.js";
function addEventListener(event, func) {
  if (ZOCIAL_IS_BROWSER && !ZOCIAL_IS_SERVICE_WORKER) {
    importPageLifecycle().then((lifecycle2) => {
      lifecycle2.addEventListener(event, func);
    });
  }
}
function removeEventListener(event, func) {
  if (ZOCIAL_IS_BROWSER && !ZOCIAL_IS_SERVICE_WORKER) {
    importPageLifecycle().then((lifecycle2) => {
      lifecycle2.removeEventListener(event, func);
    });
  }
}
export const lifecycle = { addEventListener, removeEventListener };
